import {
  BasketballAttributeId,
  BasketballEventStatusId,
  BasketballIncidentId,
  BasketballThreePointShotMadeAttribute,
  BasketballThreePointShotMissedAttribute,
} from '@collector/sportsapi-client-legacy'

import {
  getBlockedPitchIncidentsMap,
  PitchIncidents,
  PitchIncidentsConfig,
} from '../../configuration'
import { pitchBlockedEventStatus } from './pitchBlockedEventStatus'

const pitchIncidents: PitchIncidents<
  BasketballIncidentId,
  BasketballAttributeId
> = {
  separator: {
    rowStart: 2,
    colStart: 3,
    rowSpan: 4,
  },
  gridClass:
    'grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto_minmax(0,1fr)_minmax(0,1fr)]',
  incidentButtonData: [
    [
      {
        incidentId: BasketballIncidentId.InPossession,
        name: 'Possession',
        class: 'col-span-5',
      },
    ],
    [
      {
        incidentId: BasketballIncidentId.ThreePointShotMade,
        attributeId: BasketballThreePointShotMadeAttribute.JumpShot,
        name: '3pt +',
        breakLine: true,
      },
      {
        incidentId: BasketballIncidentId.ThreePointShotMissed,
        attributeId: BasketballThreePointShotMissedAttribute.JumpShot,
        name: '3 MISS',
        breakLine: true,
      },
      {
        incidentId: BasketballIncidentId.OffensiveRebound,
        name: 'Off. Reb',
      },
      {
        incidentId: BasketballIncidentId.DefensiveRebound,
        name: 'Def. Reb',
      },
    ],
    [
      {
        incidentId: BasketballIncidentId.TwoPointShotMade,
        name: '2pt +',
        breakLine: true,
      },
      {
        incidentId: BasketballIncidentId.TwoPointShotMissed,
        name: '2 MISS',
        breakLine: true,
      },
      {
        incidentId: BasketballIncidentId.Turnover,
        name: 'Turn\u200Bover', // Zero-width space (to break line in "Turnover" looking like 1 word)
      },
      {
        incidentId: BasketballIncidentId.Steal,
      },
    ],
    [
      {
        incidentId: BasketballIncidentId.FreeThrowIn,
        name: 'FT +',
        breakLine: true,
      },
      {
        incidentId: BasketballIncidentId.FreeThrowMissed,
        name: 'FT MISS',
        breakLine: true,
      },
      {
        incidentId: BasketballIncidentId.Block,
      },
      {
        incidentId: BasketballIncidentId.Foul,
      },
    ],
    [
      {
        incidentId: BasketballIncidentId.FreeThrowsAwarded,
        name: 'FT Awarded',
        class: 'col-span-2',
      },
      { incidentId: BasketballIncidentId.ThrowIn, name: 'Throw In' },
      { incidentId: BasketballIncidentId.Injury },
    ],
  ],
}

const eventStatusToBlockedPitchIncidentsTextMap = new Map<
  BasketballEventStatusId,
  string
>([
  [BasketballEventStatusId.NotStarted, 'start 1st quarter'],
  [BasketballEventStatusId.StartDelayed, 'start 1st quarter'],
  [BasketballEventStatusId.BreakAfterFirstQuarter, 'start 2nd quarter'],
  [BasketballEventStatusId.BreakAfterSecondQuarter, 'start 3rd quarter'],
  [BasketballEventStatusId.BreakAfterThirdQuarter, 'start 4th quarter'],
  [BasketballEventStatusId.BreakAfterFirstHalf, 'start 2nd half'],
  [BasketballEventStatusId.WaitingForOvertime, 'start 1st overtime'],
  [BasketballEventStatusId.BreakAfterFirstOvertime, 'start 2nd overtime'],
  [BasketballEventStatusId.BreakAfterSecondOvertime, 'start 3rd overtime'],
  [BasketballEventStatusId.BreakAfterThirdOvertime, 'start 4th overtime'],
  [BasketballEventStatusId.BreakAfterFourthOvertime, 'start 5th overtime'],
])

const blockedPitchIncidentsMap = getBlockedPitchIncidentsMap(
  pitchBlockedEventStatus,
  pitchIncidents.incidentButtonData,
)

export const pitchIncidentsConfig: PitchIncidentsConfig<
  BasketballEventStatusId,
  BasketballIncidentId,
  BasketballAttributeId
> = {
  pitchIncidents,
  blockedPitchIncidentsMap,
  eventStatusToBlockedPitchIncidentsTextMap,
}
